import React from "react";
import dreamcar from "images/dreamcar.png";
import Badge from "shared/Badge/Badge";

const steps = [
  {
    id: 1,
    icon: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="60"
          width="60"
          height="60"
          rx="20"
          transform="rotate(-90 0 60)"
          fill="#09B62C"
        />
        <rect
          width="24"
          height="24"
          transform="translate(18 18)"
          fill="#09B62C"
        />
        <path
          d="M25.75 29C25.75 28.5858 25.4142 28.25 25 28.25C24.5858 28.25 24.25 28.5858 24.25 29L24.25 34C24.25 34.4142 24.5858 34.75 25 34.75C25.4142 34.75 25.75 34.4142 25.75 34L25.75 29Z"
          fill="white"
        />
        <path
          d="M30 25.25C30.4142 25.25 30.75 25.5858 30.75 26V34C30.75 34.4142 30.4142 34.75 30 34.75C29.5858 34.75 29.25 34.4142 29.25 34V26C29.25 25.5858 29.5858 25.25 30 25.25Z"
          fill="white"
        />
        <path
          d="M35.75 31C35.75 30.5858 35.4142 30.25 35 30.25C34.5858 30.25 34.25 30.5858 34.25 31V34C34.25 34.4142 34.5858 34.75 35 34.75C35.4142 34.75 35.75 34.4142 35.75 34V31Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.5266 20.25H24.4734C23.797 20.25 23.2515 20.25 22.8075 20.2803C22.3509 20.3114 21.9472 20.3771 21.5649 20.5355C20.6461 20.9161 19.9161 21.6461 19.5355 22.5649C19.3771 22.9472 19.3114 23.3509 19.2803 23.8075C19.25 24.2515 19.25 24.797 19.25 25.4734V34.5266C19.25 35.203 19.25 35.7485 19.2803 36.1925C19.3114 36.6491 19.3771 37.0528 19.5355 37.4351C19.9161 38.3539 20.6461 39.0839 21.5649 39.4645C21.9472 39.6229 22.3509 39.6886 22.8075 39.7197C23.2515 39.75 23.797 39.75 24.4734 39.75H35.5266C36.203 39.75 36.7485 39.75 37.1925 39.7197C37.6491 39.6886 38.0528 39.6229 38.4351 39.4645C39.3539 39.0839 40.0839 38.3539 40.4645 37.4351C40.6229 37.0528 40.6886 36.6491 40.7197 36.1925C40.75 35.7485 40.75 35.203 40.75 34.5266V25.4734C40.75 24.797 40.75 24.2515 40.7197 23.8075C40.6886 23.3509 40.6229 22.9472 40.4645 22.5649C40.0839 21.6461 39.3539 20.9161 38.4351 20.5355C38.0528 20.3771 37.6491 20.3114 37.1925 20.2803C36.7485 20.25 36.203 20.25 35.5266 20.25ZM22.139 21.9213C22.308 21.8513 22.5294 21.8027 22.9096 21.7768C23.2965 21.7504 23.7908 21.75 24.5 21.75H35.5C36.2092 21.75 36.7035 21.7504 37.0904 21.7768C37.4706 21.8027 37.692 21.8513 37.861 21.9213C38.4124 22.1496 38.8504 22.5876 39.0787 23.139C39.1487 23.308 39.1973 23.5294 39.2232 23.9096C39.2496 24.2965 39.25 24.7908 39.25 25.5V34.5C39.25 35.2092 39.2496 35.7035 39.2232 36.0904C39.1973 36.4706 39.1487 36.692 39.0787 36.861C38.8504 37.4124 38.4124 37.8504 37.861 38.0787C37.692 38.1487 37.4706 38.1973 37.0904 38.2232C36.7035 38.2496 36.2092 38.25 35.5 38.25H24.5C23.7908 38.25 23.2965 38.2496 22.9096 38.2232C22.5294 38.1973 22.308 38.1487 22.139 38.0787C21.5876 37.8504 21.1496 37.4124 20.9213 36.861C20.8513 36.692 20.8027 36.4706 20.7768 36.0904C20.7504 35.7035 20.75 35.2092 20.75 34.5V25.5C20.75 24.7908 20.7504 24.2965 20.7768 23.9096C20.8027 23.5294 20.8513 23.308 20.9213 23.139C21.1496 22.5876 21.5876 22.1496 22.139 21.9213Z"
          fill="white"
        />
      </svg>
    ),
    title: "Pick a rental",
    description: "Choose from a growing selection of Exotic Cars.",
  },
  {
    id: 2,
    icon: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="60"
          width="60"
          height="60"
          rx="20"
          transform="rotate(-90 0 60)"
          fill="#09B62C"
        />
        <rect
          width="24"
          height="24"
          transform="translate(18 18)"
          fill="#09B62C"
        />
        <path
          d="M25.75 29C25.75 28.5858 25.4142 28.25 25 28.25C24.5858 28.25 24.25 28.5858 24.25 29L24.25 34C24.25 34.4142 24.5858 34.75 25 34.75C25.4142 34.75 25.75 34.4142 25.75 34L25.75 29Z"
          fill="white"
        />
        <path
          d="M30 25.25C30.4142 25.25 30.75 25.5858 30.75 26V34C30.75 34.4142 30.4142 34.75 30 34.75C29.5858 34.75 29.25 34.4142 29.25 34V26C29.25 25.5858 29.5858 25.25 30 25.25Z"
          fill="white"
        />
        <path
          d="M35.75 31C35.75 30.5858 35.4142 30.25 35 30.25C34.5858 30.25 34.25 30.5858 34.25 31V34C34.25 34.4142 34.5858 34.75 35 34.75C35.4142 34.75 35.75 34.4142 35.75 34V31Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.5266 20.25H24.4734C23.797 20.25 23.2515 20.25 22.8075 20.2803C22.3509 20.3114 21.9472 20.3771 21.5649 20.5355C20.6461 20.9161 19.9161 21.6461 19.5355 22.5649C19.3771 22.9472 19.3114 23.3509 19.2803 23.8075C19.25 24.2515 19.25 24.797 19.25 25.4734V34.5266C19.25 35.203 19.25 35.7485 19.2803 36.1925C19.3114 36.6491 19.3771 37.0528 19.5355 37.4351C19.9161 38.3539 20.6461 39.0839 21.5649 39.4645C21.9472 39.6229 22.3509 39.6886 22.8075 39.7197C23.2515 39.75 23.797 39.75 24.4734 39.75H35.5266C36.203 39.75 36.7485 39.75 37.1925 39.7197C37.6491 39.6886 38.0528 39.6229 38.4351 39.4645C39.3539 39.0839 40.0839 38.3539 40.4645 37.4351C40.6229 37.0528 40.6886 36.6491 40.7197 36.1925C40.75 35.7485 40.75 35.203 40.75 34.5266V25.4734C40.75 24.797 40.75 24.2515 40.7197 23.8075C40.6886 23.3509 40.6229 22.9472 40.4645 22.5649C40.0839 21.6461 39.3539 20.9161 38.4351 20.5355C38.0528 20.3771 37.6491 20.3114 37.1925 20.2803C36.7485 20.25 36.203 20.25 35.5266 20.25ZM22.139 21.9213C22.308 21.8513 22.5294 21.8027 22.9096 21.7768C23.2965 21.7504 23.7908 21.75 24.5 21.75H35.5C36.2092 21.75 36.7035 21.7504 37.0904 21.7768C37.4706 21.8027 37.692 21.8513 37.861 21.9213C38.4124 22.1496 38.8504 22.5876 39.0787 23.139C39.1487 23.308 39.1973 23.5294 39.2232 23.9096C39.2496 24.2965 39.25 24.7908 39.25 25.5V34.5C39.25 35.2092 39.2496 35.7035 39.2232 36.0904C39.1973 36.4706 39.1487 36.692 39.0787 36.861C38.8504 37.4124 38.4124 37.8504 37.861 38.0787C37.692 38.1487 37.4706 38.1973 37.0904 38.2232C36.7035 38.2496 36.2092 38.25 35.5 38.25H24.5C23.7908 38.25 23.2965 38.2496 22.9096 38.2232C22.5294 38.1973 22.308 38.1487 22.139 38.0787C21.5876 37.8504 21.1496 37.4124 20.9213 36.861C20.8513 36.692 20.8027 36.4706 20.7768 36.0904C20.7504 35.7035 20.75 35.2092 20.75 34.5V25.5C20.75 24.7908 20.7504 24.2965 20.7768 23.9096C20.8027 23.5294 20.8513 23.308 20.9213 23.139C21.1496 22.5876 21.5876 22.1496 22.139 21.9213Z"
          fill="white"
        />
      </svg>
    ),
    title: "Pay for booking",
    description: "Select a date, time and submit your payment.",
  },
  {
    id: 3,
    icon: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="60"
          width="60"
          height="60"
          rx="20"
          transform="rotate(-90 0 60)"
          fill="#09B62C"
        />
        <rect
          width="24"
          height="24"
          transform="translate(18 18)"
          fill="#09B62C"
        />
        <path
          d="M25.75 29C25.75 28.5858 25.4142 28.25 25 28.25C24.5858 28.25 24.25 28.5858 24.25 29L24.25 34C24.25 34.4142 24.5858 34.75 25 34.75C25.4142 34.75 25.75 34.4142 25.75 34L25.75 29Z"
          fill="white"
        />
        <path
          d="M30 25.25C30.4142 25.25 30.75 25.5858 30.75 26V34C30.75 34.4142 30.4142 34.75 30 34.75C29.5858 34.75 29.25 34.4142 29.25 34V26C29.25 25.5858 29.5858 25.25 30 25.25Z"
          fill="white"
        />
        <path
          d="M35.75 31C35.75 30.5858 35.4142 30.25 35 30.25C34.5858 30.25 34.25 30.5858 34.25 31V34C34.25 34.4142 34.5858 34.75 35 34.75C35.4142 34.75 35.75 34.4142 35.75 34V31Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.5266 20.25H24.4734C23.797 20.25 23.2515 20.25 22.8075 20.2803C22.3509 20.3114 21.9472 20.3771 21.5649 20.5355C20.6461 20.9161 19.9161 21.6461 19.5355 22.5649C19.3771 22.9472 19.3114 23.3509 19.2803 23.8075C19.25 24.2515 19.25 24.797 19.25 25.4734V34.5266C19.25 35.203 19.25 35.7485 19.2803 36.1925C19.3114 36.6491 19.3771 37.0528 19.5355 37.4351C19.9161 38.3539 20.6461 39.0839 21.5649 39.4645C21.9472 39.6229 22.3509 39.6886 22.8075 39.7197C23.2515 39.75 23.797 39.75 24.4734 39.75H35.5266C36.203 39.75 36.7485 39.75 37.1925 39.7197C37.6491 39.6886 38.0528 39.6229 38.4351 39.4645C39.3539 39.0839 40.0839 38.3539 40.4645 37.4351C40.6229 37.0528 40.6886 36.6491 40.7197 36.1925C40.75 35.7485 40.75 35.203 40.75 34.5266V25.4734C40.75 24.797 40.75 24.2515 40.7197 23.8075C40.6886 23.3509 40.6229 22.9472 40.4645 22.5649C40.0839 21.6461 39.3539 20.9161 38.4351 20.5355C38.0528 20.3771 37.6491 20.3114 37.1925 20.2803C36.7485 20.25 36.203 20.25 35.5266 20.25ZM22.139 21.9213C22.308 21.8513 22.5294 21.8027 22.9096 21.7768C23.2965 21.7504 23.7908 21.75 24.5 21.75H35.5C36.2092 21.75 36.7035 21.7504 37.0904 21.7768C37.4706 21.8027 37.692 21.8513 37.861 21.9213C38.4124 22.1496 38.8504 22.5876 39.0787 23.139C39.1487 23.308 39.1973 23.5294 39.2232 23.9096C39.2496 24.2965 39.25 24.7908 39.25 25.5V34.5C39.25 35.2092 39.2496 35.7035 39.2232 36.0904C39.1973 36.4706 39.1487 36.692 39.0787 36.861C38.8504 37.4124 38.4124 37.8504 37.861 38.0787C37.692 38.1487 37.4706 38.1973 37.0904 38.2232C36.7035 38.2496 36.2092 38.25 35.5 38.25H24.5C23.7908 38.25 23.2965 38.2496 22.9096 38.2232C22.5294 38.1973 22.308 38.1487 22.139 38.0787C21.5876 37.8504 21.1496 37.4124 20.9213 36.861C20.8513 36.692 20.8027 36.4706 20.7768 36.0904C20.7504 35.7035 20.75 35.2092 20.75 34.5V25.5C20.75 24.7908 20.7504 24.2965 20.7768 23.9096C20.8027 23.5294 20.8513 23.308 20.9213 23.139C21.1496 22.5876 21.5876 22.1496 22.139 21.9213Z"
          fill="white"
        />
      </svg>
    ),
    title: "Proof of insurance",
    description: "Make sure you meet the insurance requirements.",
  },
];

const Card = ({
  step,
}: {
  step: { id: number; icon: any; title: string; description: string };
}) => {
  return (
    <div className="flex max-w-sm items-start p-4  rounded-xl shadow-md bg-[#F5F5F7] space-x-4">
      {step.icon}
      <div>
        <h3 className="text-lg font-semibold">
          <Badge color="green" name={`Step-${step.id}`} />
          <br /> {step.title}
        </h3>
        <p className="text-gray-600">{step.description}</p>
      </div>
    </div>
  );
};

const DreamCarSection = () => {
  return (
    <>
      <h2 className="text-4xl font-bold text-center mb-12">
        Drive Your Dream Car
      </h2>
      <div className="flex flex-col items-center p-6 md:flex-row gap-12 xl:gap-24 md:space-x-10">
        <div className="w-full rounded-lg overflow-hidden shadow-lg">
          <img
            src={dreamcar}
            alt="Exotic Cars"
            className="w-full h-auto rounded-lg"
          />
        </div>

        <div className="w-full space-y-6">
          {steps.map((step) => (
            <Card key={step.id} step={step} />
          ))}
        </div>
      </div>
    </>
  );
};

export default DreamCarSection;
